export default function* chunks(arr, n){ //split array into chunks
    for( let i = 0; i < arr.length; i += n){
      yield arr.slice(i, i + n);
    }
}
